import './CardBlock.scss';

import { createApp, defineAsyncComponent } from 'vue';

const mountingCardGridBlocks = document.querySelectorAll(
	'[data-feature="card-block-video"]'
);
if (mountingCardGridBlocks) {
	mountingCardGridBlocks.forEach((block) => {
		const CardBlockVideo = defineAsyncComponent(
			() => import('./CardBlockVideo.vue')
		);

		const app = createApp({
			name: 'CardBlockVideoApp',
		});
		app.component('card-block-video', CardBlockVideo);
		app.mount(block);
	});
}
